interface ValidationOutput {
  minCaracteres: boolean;
  especialCaracteres: boolean;
  maiusculas: boolean;
  minusculas: boolean;
  numeros: boolean;
  passwordRegexPattern: boolean;
}

export function ValidationCampos(values: any): ValidationOutput {
  const minCaracteres = /[0-9a-zA-Z$*&@#]{8,}/.test(values);

  const especialCaracteres = /[`!@#$&*{}~]/g.test(values);

  const maiusculas = /[`A-Z?~]/g.test(values);

  const minusculas = /[`a-z?~]/g.test(values);

  const numeros = /[`0-9?~]/g.test(values);

  const passwordRegexPattern =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_.])[A-Za-z\d@$!%*#?&_.]{8,}$/g.test(
      values
    );

  return {
    minCaracteres,
    especialCaracteres,
    maiusculas,
    minusculas,
    numeros,
    passwordRegexPattern,
  };
}
